import styled from "styled-components";

export const AccordionWrapper = styled.div`
  .MuiButtonBase-root {
    width: 100%;
    padding: 12px 20px;
    min-height: 45px;
  }
  .card-view {
    display: initial !important ;
  }
  .align-right {
    text-align: right;
  }
  .align-left {
  text-align: left;
  }
  .MuiAccordionSummary-content {
    margin: 0;
    p {
      display: flex;
      align-items: center;
      gap: 14px;
      font-size: 16px;
      line-height: 19px;
      color: #1d1d1d;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    }
  }
  .MuiAccordion-gutters {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    box-shadow: none;
    margin-bottom: 4px !important;
  }
  .Mui-expanded {
    margin-bottom: 4px !important;
    overflow: hidden;
  }
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }
  .MuiAccordionSummary-root.Mui-expanded {
    min-height: auto;
  }
  .MuiAccordionDetails-root {
    background: #f5f5f5;
    padding: 12px 22px;
    border-top: 1px solid #00000033;
  }
`;
